<script>
export default {
  methods: {},
  props: {},
  data: function () {
    return {};
  },
  computed: {},
};
</script>
    
<template>
  <div class="f-radio-button-cards">
    <slot></slot>
  </div>
</template>

<style lang="scss">
.f-radio-button-cards {
  margin: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .f-radio-button-card {
  }
}

.dark-mode {
  .f-radio-button-cards {
    margin: 0;
  }
}
</style>